import { StaticPage } from '../types/pages';
import { useStaticPages } from './use-static-pages-data';

export const useStaticPageDataResolver = () => {
  const data = useStaticPages();

  return (page: StaticPage) => data[page];
};
